import { NavBar } from "@/components/NavBar"
import './MQuiz.scss'
import { atom, selector, useRecoilCallback, useRecoilState, useRecoilValue } from "recoil";
import { quizState, submitAmswerState, userSelectedIdsState } from "@/models/quizState";
import { ImageViewer, Toast, } from "antd-mobile";
import produce from 'immer';
import { QuizAlertTypes, QuizAlert, alertLoadingState } from "@/components/Alert";
import { AnswerModel, QuestionModel } from "@/models/typing";
import { useEffect } from "react";
import { formatTime } from "@/utils/util";
import { Tracking } from "@/utils/tracking";
import BlankPage from "@/components/Error/blank";
import moment from 'moment';
import { paperState } from "./MPaper";
import { CError } from "@/utils/server";
import { useNavigate } from "react-router-dom";


export type QuizBootomProps = {
    allowSubmit: boolean
}

export const QuizBootom = ({ allowSubmit }: QuizBootomProps) => {
    const [quiz, setQuiz] = useRecoilState(quizState)
    return (
        <div className="mobile-quiz-bottom">
            <div>
                {
                    quiz.index > 0 && <div className="prev" onClick={(event) => {
                        event.stopPropagation()
                        setQuiz(produce(quiz, (draftState) => {
                            draftState.index = Math.max(0, quiz.index - 1)
                        }));
                    }}></div>
                }
                {
                    ((quiz.index + 1) !== quiz.questionList.length || allowSubmit) && (
                        <div className={(quiz.index + 1) === quiz.questionList.length ? 'submit' : 'next'} onClick={(event) => {
                            event.stopPropagation()
                            if (quiz.index === quiz.questionList.length - 1 && allowSubmit) {
                                Tracking.UP('click_all_answer_QuestionBank_submit', '', { 'title': quiz.questionnaire?.title ?? '' })
                                setQuiz(produce(quiz, (draftState) => {
                                    draftState.alertType = QuizAlertTypes.PAPER
                                    draftState.alert = true
                                }));
                            } else {
                                setQuiz(produce(quiz, (draftState) => {
                                    draftState.index = Math.min(quiz.questionList.length - 1, quiz.index + 1)
                                }));
                            }
                        }}></div>
                    )
                }

            </div>
            <div onClick={(event) => {
                event.stopPropagation()
                setQuiz(produce(quiz, (draftState) => {
                    draftState.navigate = !quiz.navigate
                }));
            }}>
                <img src={require('../../assets/img/m-quiz-nav-icon.png')} alt="colg" />
                <p><span>{quiz.index + 1}</span>/<span>{quiz.questionList.length}</span></p>
            </div>
        </div>
    )

}


export const QuizNavigateComponent = () => {

    const [quiz, setQuiz] = useRecoilState(quizState)

    const userSelectedIds = useRecoilValue(userSelectedIdsState)


    const selectedQuestionNavigateStyle = (item: QuestionModel, index: number) => {
        if (index === quiz.index) {
            return { color: '#FF00D8' }
        } else if (userSelectedIds[item.question_id] !== undefined && userSelectedIds[item.question_id].length > 0) {
            return { color: '#fae9af' }
        }
        return { color: '#574e2f' }
    }

    const selectedQuestionNavigateImage = (item: QuestionModel, index: number) => {
        if (index === quiz.index) {
            return require('../../assets/img/m-navigate-btn-s.png')
        } else if (userSelectedIds[item.question_id] !== undefined && userSelectedIds[item.question_id].length > 0) {
            return require('../../assets/img/m-navigate-btn-u.png')
        }
        return require('../../assets/img/m-navigate-btn-n.png')
    }



    return (
        <div className="mobile-question-navigate">
            <div className="navigate-gird-container">
                {
                    quiz.questionList.map((item, index) => (
                        <div className="navigate-btn"
                            key={index}
                            style={selectedQuestionNavigateStyle(item, index)}
                            onClick={(event) => {
                                event.stopPropagation()
                                setQuiz(produce(quiz, (draftState) => {
                                    draftState.index = index
                                    draftState.navigate = false
                                }))
                            }}
                        >
                            <img src={selectedQuestionNavigateImage(item, index)} alt="colg" />
                            <p>{index + 1}</p>
                        </div>
                    ))
                }
            </div>
            <div className="navigate-bottom">
                <div className="navigate-bottom-button" onClick={(event) => {
                    event.stopPropagation()
                    setQuiz(produce(quiz, (draftState) => {
                        draftState.navigate = false
                    }))
                }}></div>
            </div>
        </div>
    )
}

export type QuizAnswerComponentProps = {
    question: QuestionModel
    item: AnswerModel
    index: number
    allowClick: boolean
}

export const QuizAnswerComponent = ({ question, item, index, allowClick }: QuizAnswerComponentProps) => {

    const [quiz, setQuiz] = useRecoilState(quizState)

    const [userSelectedIds, setUserSelectedIds] = useRecoilState(userSelectedIdsState)

    const handleSelect = (id: string) => {

        setUserSelectedIds((prevState) =>
            produce(prevState, (draftState) => {
                let answers = draftState[question.question_id]
                if (question.type === 2) {
                    const uniqueSet = new Set(answers)
                    uniqueSet.add(id)
                    draftState[question.question_id] = Array.from(uniqueSet)
                } else {
                    draftState[question.question_id] = [id]
                }
            })
        );
    }

    const selectedAnswerStyle = (answerId: string) => {
        if (userSelectedIds[question.question_id] !== undefined) {
            if (userSelectedIds[question.question_id].includes(answerId)) {
                return { color: '#FF00D8' }
            }
        }
        return { color: '#C6B782' }
    }

    const selectedAnswerTagStyle = (answerId: string) => {
        if (userSelectedIds[question.question_id] !== undefined) {
            if (userSelectedIds[question.question_id].includes(answerId)) {
                return 's'
            }
        }
        return 'n'
    }

    return (
        <div className="answer" style={selectedAnswerStyle(item.answer_id)} onClick={(event) => {
            event.stopPropagation()
            if (allowClick) {
                handleSelect(item.answer_id)
            }
        }}>
            <div className={`tag tag-index-${selectedAnswerTagStyle(item.answer_id)}-${index}`}></div>
            <div className="content">
                <p>
                    {item.name}
                </p>
                {
                    item.img.length > 0 && <img className="img" src={item.img} onClick={(event) => {
                        event.stopPropagation()
                        if (!allowClick) {
                            setQuiz(produce(quiz, (draftState) => {
                                draftState.image = item.img
                                draftState.visible = true
                            }))
                            return
                        }
                        setQuiz(produce(quiz, (draftState) => {
                            draftState.image = item.img
                            draftState.visible = true
                        }))
                    }} alt="colg" />
                }
            </div>

        </div>
    )
}


export const queryQuestionState = selector<QuestionModel | undefined>({
    key: 'queryQuestionState',
    get: ({ get }) => {
        const quiz = get(quizState);
        const questionList = quiz.questionList;
        const index = quiz.index;
        return questionList[index] || undefined;
    }
})


export const countdownState = atom<number>({
    key: 'countdownState',
    default: 0,
})


export const MobileQuiz = () => {

    const navigate = useNavigate()

    const [quiz, setQuiz] = useRecoilState(quizState)

    const question = useRecoilValue(queryQuestionState)

    const [paper, setPaper] = useRecoilState(paperState)

    const [countdown, setCountdown] = useRecoilState(countdownState)

    const [alertLoading, setAlertLoading] = useRecoilState(alertLoadingState)

    const submitAnswers = useRecoilCallback(({ snapshot }) => async () => {
        try {
            setAlertLoading(true)
            const result = await snapshot.getPromise(submitAmswerState)
            setAlertLoading(false)
            setPaper(result)
            navigate('/paper', { replace: true })
            setQuiz(produce(quiz, (draftState) => {
                draftState.alertType = QuizAlertTypes.TIMEOUT
                draftState.alert = true
            }));
        } catch (error) {
            setAlertLoading(false)
            const err = error as CError
            if(err.code === 756004){
                navigate('/', { replace: true })
            }
            Toast.show({ content: err.message })
        }
    }, [alertLoading, paper])


    useEffect(() => {
        if (quiz.questionnaire && quiz.questionnaire.answer_time > 0) {

            let animationFrameId: number;
            let startTime: number;
            const currentTime = moment();
            const targetDate = currentTime.add(quiz.questionnaire.answer_time, 'seconds'); 
            const startTimer = (timestamp: number) => {
                if (!startTime) {
                    startTime = timestamp;
                }
                const now = moment();
                const diff = targetDate.diff(now);
                if (diff <= 0) {
                    setCountdown(0);
                    cancelAnimationFrame(animationFrameId);
                    submitAnswers();
                } else {
                    const seconds = Math.floor(diff / 1000);
                    setCountdown(seconds);
                    animationFrameId = requestAnimationFrame(startTimer);
                }
            };

            animationFrameId = requestAnimationFrame(startTimer);

            return () => {
                cancelAnimationFrame(animationFrameId);
            };
        }

    }, [setCountdown]);


    if (question === undefined) {
        return <BlankPage />
    }

    return (
        <div className="mobile-quiz">
            <NavBar backTitle="退出答题"
                titleString={quiz.questionnaire?.title ?? ''}
                titleStyle={{ color: '#E0D49C', fontSize: '0.42rem', lineHeight: '0.47rem', textAlign: 'center' }}
                onBackClick={() => {
                    setQuiz(produce(quiz, (draftState) => {
                        draftState.alertType = QuizAlertTypes.REMIND
                        draftState.alert = true
                    }));
                }}
            />
            {
                (quiz.questionnaire && quiz.questionnaire.answer_time > 0) && <div className="countdown">
                    <div className="clock"></div>
                    <p className="timeline">{formatTime(countdown)}</p>
                </div>
            }
            {
                !quiz.navigate && (
                    <div className="question">
                        <p className="title">{`${quiz.index + 1}. ${question.title}`}</p>
                        {
                            question.img.length > 0 && <img
                                className="question-img"
                                src={question.img}
                                onClick={(event) => {
                                    event.stopPropagation()
                                    setQuiz(produce(quiz, (draftState) => {
                                        draftState.image = question.img
                                        draftState.visible = true
                                    }))
                                }}
                                alt="colg"
                            />
                        }
                        {
                            question.answer_list.map((item, index) => (
                                <QuizAnswerComponent key={index} question={question} item={item} index={index} allowClick={true} />
                            ))
                        }
                    </div>
                )
            }
            <ImageViewer
                image={quiz.image}
                visible={quiz.visible}
                onClose={() => {
                    setQuiz(produce(quiz, (draftState) => {
                        draftState.image = ''
                        draftState.visible = false
                    }))
                }}
            />
            {!quiz.navigate && <QuizBootom allowSubmit={true} />}
            {quiz.navigate && <QuizNavigateComponent />}
            {quiz.alert && <QuizAlert />}
        </div>
    )

}


